'use client'

import Image from 'next/image'
import Link from 'next/link'
import React, { ComponentProps } from 'react'

type Props = {
  langType: 'EN' | 'JP'
} & Partial<ComponentProps<typeof Image>>

const ADDITIONAL_TRIAL_BANNER_SRC = '/images/banners/trial-additional.png'

export const LanguageTrialBanner = ({ langType, ...props }: Props) => {
  const href = '/subscribes/trial'

  return (
    <header aria-label={`language-trial-banner-${langType}`}>
      <Link href={href}>
        <Image
          src={ADDITIONAL_TRIAL_BANNER_SRC}
          alt={`trial banner ${langType}`}
          width={460}
          height={115}
          className="w-full h-auto"
          {...props}
        />
      </Link>
    </header>
  )
}
